import aucklandCity from "../../images/Paintings/Cityscapes/01_aucklandCity.jpg";
import bricklane from "../../images/Paintings/Cityscapes/02_bricklane.jpg";
import oxfordCircus from "../../images/Paintings/Cityscapes/03_oxfordCircus.jpg";
import debtCollectors from "../../images/Paintings/Cityscapes/04_debtCollectors.jpg";
import longerHotterSummer from "../../images/Paintings/Cityscapes/05_longerHotterSummer.jpg";
import davidMeetsHelen from "../../images/Paintings/Cityscapes/06_davidMeetsHelen.jpg";
import ptChev3 from "../../images/Paintings/Cityscapes/07_ptChev3.jpg";
import theEndofRecession from "../../images/Paintings/Cityscapes/08_theEndofRecession.jpg";
import aLongHotSummer from "../../images/Paintings/Cityscapes/09_aLongHotSummer.jpg";
import rockyHorrorShow from "../../images/Paintings/Cityscapes/10_rockyHorrorShow.jpg";
import berkeleySquare from "../../images/Paintings/Cityscapes/11_berkeleySquare.jpg";
import coventGarden from "../../images/Paintings/Cityscapes/12_coventGarden.jpg";
import nightIsYoung from "../../images/Paintings/Cityscapes/13_nightIsYoung.jpg";
import piccadilyCircus1961 from "../../images/Paintings/Cityscapes/14_piccadilyCircus1961.jpg";
import greenPark from "../../images/Paintings/Cityscapes/15_greenPark.jpg";
import flowerMarket from "../../images/Paintings/Cityscapes/16_flowerMarket.jpg";
import shootingStar from "../../images/Paintings/Cityscapes/17_shootingStar.jpg";
import fountainOfYouth from "../../images/Paintings/Cityscapes/18_fountainOfYouth.jpg";
import novemberNights from "../../images/Paintings/Cityscapes/19_novemberNights.jpg";
import avenueOfAmericas from "../../images/Paintings/Cityscapes/20_avenueOfAmericas.jpg";
import futureOpeningNight from "../../images/Paintings/Cityscapes/21_futureOpeningNight.jpg";
import incomingTide from "../../images/Paintings/Cityscapes/22_incomingTide.jpg";
import theBanker from "../../images/Paintings/Cityscapes/23_theBanker.jpg";
import jafa from "../../images/Paintings/Cityscapes/24_jafa.jpg";
import realGroovy from "../../images/Paintings/Cityscapes/25_realGroovy.jpg";
import intoxicatedCity from "../../images/Paintings/Cityscapes/26_intoxicatedCity.jpg";
import spiltCoke from "../../images/Paintings/Cityscapes/27_spiltCoke.jpg";
import pointChevIV from "../../images/Paintings/Cityscapes/28_pointChevIV.jpg";
import armedRobbers from "../../images/Paintings/Cityscapes/29_armedRobbers.jpg";
import bonfire from "../../images/Paintings/Cityscapes/30_bonfire.jpg";
import kRoad from "../../images/Paintings/Cityscapes/31_kRoad.jpg";
import labourDay from "../../images/Paintings/Cityscapes/32_labourDay.jpg";
import pursuitOfHappiness from "../../images/Paintings/Cityscapes/33_pursuitOfHappiness.jpg";
import thinkingOutLoud from "../../images/Paintings/Cityscapes/34_thinkingOutLoud.jpg";
import pointChev2 from "../../images/Paintings/Cityscapes/35_pointChev2.jpg";
import thePsychologist from "../../images/Paintings/Cityscapes/36_thePsychologist.jpg";
import theYear2064 from "../../images/Paintings/Cityscapes/37_theYear2064.jpg";
import camel from "../../images/Paintings/Cityscapes/38_camel.jpg";
import lion from "../../images/Paintings/Cityscapes/39_lion.jpg";
import swineFluBritomart from "../../images/Paintings/Cityscapes/40_swineFluBritomart.jpg";
import pointChev from "../../images/Paintings/Cityscapes/41_pointChev.jpg";
import happyAsLarry from "../../images/Paintings/Cityscapes/42_happyAsLarry.jpg";
import theImpressionists from "../../images/Paintings/Cityscapes/43_theImpressionists.jpg";
import palermoHollywood from "../../images/Paintings/Cityscapes/44_palermoHollywood.jpg";
import kiwisInPeru from "../../images/Paintings/Cityscapes/45_kiwisInPeru.jpg";
import mullins from "../../images/Paintings/Cityscapes/46_mullins.jpg";
import carlisleBay from "../../images/Paintings/Cityscapes/47_carlisleBay.jpg";
import madisonAve from "../../images/Paintings/Cityscapes/51_madisonAve.jpg";
import parsleyBay from "../../images/Paintings/Cityscapes/52_parsleyBay.jpg";
import fortySecondSt from "../../images/Paintings/Cityscapes/48_42ndStreet.jpg";
import fogOnQueenSt from "../../images/Paintings/Cityscapes/49_fogOnQueenSt.jpg";
import missionBay from "../../images/Paintings/Cityscapes/53_missionBay.jpg";

// 800px responsive versions for srcset
import aucklandCitySm from "../../images/Paintings/Cityscapes/sm/01_aucklandCity.jpg";
import bricklaneSm from "../../images/Paintings/Cityscapes/sm/02_bricklane.jpg";
import oxfordCircusSm from "../../images/Paintings/Cityscapes/sm/03_oxfordCircus.jpg";
import debtCollectorsSm from "../../images/Paintings/Cityscapes/sm/04_debtCollectors.jpg";
import longerHotterSummerSm from "../../images/Paintings/Cityscapes/sm/05_longerHotterSummer.jpg";
import davidMeetsHelenSm from "../../images/Paintings/Cityscapes/sm/06_davidMeetsHelen.jpg";
import ptChev3Sm from "../../images/Paintings/Cityscapes/sm/07_ptChev3.jpg";
import theEndofRecessionSm from "../../images/Paintings/Cityscapes/sm/08_theEndofRecession.jpg";
import aLongHotSummerSm from "../../images/Paintings/Cityscapes/sm/09_aLongHotSummer.jpg";
import rockyHorrorShowSm from "../../images/Paintings/Cityscapes/sm/10_rockyHorrorShow.jpg";
import berkeleySquareSm from "../../images/Paintings/Cityscapes/sm/11_berkeleySquare.jpg";
import coventGardenSm from "../../images/Paintings/Cityscapes/sm/12_coventGarden.jpg";
import nightIsYoungSm from "../../images/Paintings/Cityscapes/sm/13_nightIsYoung.jpg";
import piccadilyCircus1961Sm from "../../images/Paintings/Cityscapes/sm/14_piccadilyCircus1961.jpg";
import greenParkSm from "../../images/Paintings/Cityscapes/sm/15_greenPark.jpg";
import flowerMarketSm from "../../images/Paintings/Cityscapes/sm/16_flowerMarket.jpg";
import shootingStarSm from "../../images/Paintings/Cityscapes/sm/17_shootingStar.jpg";
import fountainOfYouthSm from "../../images/Paintings/Cityscapes/sm/18_fountainOfYouth.jpg";
import novemberNightsSm from "../../images/Paintings/Cityscapes/sm/19_novemberNights.jpg";
import avenueOfAmericasSm from "../../images/Paintings/Cityscapes/sm/20_avenueOfAmericas.jpg";
import futureOpeningNightSm from "../../images/Paintings/Cityscapes/sm/21_futureOpeningNight.jpg";
import incomingTideSm from "../../images/Paintings/Cityscapes/sm/22_incomingTide.jpg";
import theBankerSm from "../../images/Paintings/Cityscapes/sm/23_theBanker.jpg";
import jafaSm from "../../images/Paintings/Cityscapes/sm/24_jafa.jpg";
import realGroovySm from "../../images/Paintings/Cityscapes/sm/25_realGroovy.jpg";
import intoxicatedCitySm from "../../images/Paintings/Cityscapes/sm/26_intoxicatedCity.jpg";
import spiltCokeSm from "../../images/Paintings/Cityscapes/sm/27_spiltCoke.jpg";
import pointChevIVSm from "../../images/Paintings/Cityscapes/sm/28_pointChevIV.jpg";
import armedRobbersSm from "../../images/Paintings/Cityscapes/sm/29_armedRobbers.jpg";
import bonfireSm from "../../images/Paintings/Cityscapes/sm/30_bonfire.jpg";
import kRoadSm from "../../images/Paintings/Cityscapes/sm/31_kRoad.jpg";
import labourDaySm from "../../images/Paintings/Cityscapes/sm/32_labourDay.jpg";
import pursuitOfHappinessSm from "../../images/Paintings/Cityscapes/sm/33_pursuitOfHappiness.jpg";
import thinkingOutLoudSm from "../../images/Paintings/Cityscapes/sm/34_thinkingOutLoud.jpg";
import pointChev2Sm from "../../images/Paintings/Cityscapes/sm/35_pointChev2.jpg";
import thePsychologistSm from "../../images/Paintings/Cityscapes/sm/36_thePsychologist.jpg";
import theYear2064Sm from "../../images/Paintings/Cityscapes/sm/37_theYear2064.jpg";
import camelSm from "../../images/Paintings/Cityscapes/sm/38_camel.jpg";
import lionSm from "../../images/Paintings/Cityscapes/sm/39_lion.jpg";
import swineFluBritomartSm from "../../images/Paintings/Cityscapes/sm/40_swineFluBritomart.jpg";
import pointChevSm from "../../images/Paintings/Cityscapes/sm/41_pointChev.jpg";
import happyAsLarrySm from "../../images/Paintings/Cityscapes/sm/42_happyAsLarry.jpg";
import theImpressionistsSm from "../../images/Paintings/Cityscapes/sm/43_theImpressionists.jpg";
import palermoHollywoodSm from "../../images/Paintings/Cityscapes/sm/44_palermoHollywood.jpg";
import kiwisInPeruSm from "../../images/Paintings/Cityscapes/sm/45_kiwisInPeru.jpg";
import mullinsSm from "../../images/Paintings/Cityscapes/sm/46_mullins.jpg";
import carlisleBaySm from "../../images/Paintings/Cityscapes/sm/47_carlisleBay.jpg";
import madisonAveSm from "../../images/Paintings/Cityscapes/sm/51_madisonAve.jpg";
import parsleyBaySm from "../../images/Paintings/Cityscapes/sm/52_parsleyBay.jpg";
import fortySecondStSm from "../../images/Paintings/Cityscapes/sm/48_42ndStreet.jpg";
import fogOnQueenStSm from "../../images/Paintings/Cityscapes/sm/49_fogOnQueenSt.jpg";
import missionBaySm from "../../images/Paintings/Cityscapes/sm/53_missionBay.jpg";

const cityscapesCollection = [
  {
    image: aucklandCity,
    imageSm: aucklandCitySm,
    title: "Auckland City",
    description: "Oil on canvas. 110cm x 140cm. 2011",
    alt: "Auckland City. Oil on canvas. 110cm x 140cm. 2011",
  },
  {
    image: bricklane,
    imageSm: bricklaneSm,
    title: "Bricklane- London",
    description: "Oil on canvas. 27cm X 44cm. 2013.",
    alt: "Bricklane- London. Oil on canvas. 27cm X 44cm. 2013",
  },
  {
    image: oxfordCircus,
    imageSm: oxfordCircusSm,
    title: "Oxford Circus- London",
    description: "Oil on canvas. 61cm x 76cm. 2013",
    alt: "Oxford Circus- London. Oil on canvas. 61cm x 76cm. 2013",
  },
  {
    image: debtCollectors,
    imageSm: debtCollectorsSm,
    title: "Debt Collectors at Piccadilly Circus",
    description: "Oil on canvas. 120cm x 150cm. 2012",
    alt: "Debt Collectors at Piccadilly Circus. Oil on canvas. 120cm x 150cm. 2012",
  },
  {
    image: longerHotterSummer,
    imageSm: longerHotterSummerSm,
    title: "Longer Hotter Summer",
    description: "Oil on canvas. 115cm x 140cm. 2010",
    alt: "Longer Hotter Summer. Oil on canvas. 115cm x 140cm. 2010",
  },
  {
    image: davidMeetsHelen,
    imageSm: davidMeetsHelenSm,
    title: "David meets Helen",
    description: "Oil on canvas. 130cm X 110cm. 2014",
    alt: "David meets Helen. Oil on canvas. 130cm X 110cm. 2014",
  },
  {
    image: ptChev3,
    imageSm: ptChev3Sm,
    title: "Point Chev III- Lazy Sunday Afternoon",
    description: "Oil on canvas. 100cm x 80cm. 2010",
    alt: "Point Chev III- Lazy Sunday Afternoon. Oil on canvas. 100cm x 80cm. 2010",
  },
  {
    image: theEndofRecession,
    imageSm: theEndofRecessionSm,
    title: "The End of the Recession",
    description: "Oil on canvas. 140cm x 180cm. 2009",
    alt: "The End of the Recession. Oil on canvas. 140cm x 180cm. 2009",
  },
  {
    image: madisonAve,
    imageSm: madisonAveSm,
    title: "694 Madison Ave",
    description: "Oil on linen. 96cm x 71cm. 2025",
    alt: "694 Madison Ave. Oil on linen. 96cm x 71cm. 2025",
  },
  {
    image: parsleyBay,
    imageSm: parsleyBaySm,
    title: "Parsley Bay",
    description: "Oil on linen. 163cm x 163cm. 2025",
    alt: "Parsley Bay. Oil on linen. 163cm x 163cm. 2025",
  },
  {
    image: aLongHotSummer,
    imageSm: aLongHotSummerSm,
    title: "A Long Hot Summer",
    description: "Oil on board. 120cm x 90cm. 2009",
    alt: "A Long Hot Summer. Oil on board. 120cm x 90cm. 2009",
  },
  {
    image: rockyHorrorShow,
    imageSm: rockyHorrorShowSm,
    title: "Rocky Horror Show at The Civic",
    description: "Oil on canvas. 110cm x 140cm. 2011",
    alt: "Rocky Horror Show at The Civic. Oil on canvas. 110cm x 140cm. 2011",
  },
  {
    image: berkeleySquare,
    imageSm: berkeleySquareSm,
    title: "Summer Lunch- Berkeley Square, Mayfair",
    description: "Oil on canvas. 40cm x 50cm. 2012",
    alt: "Summer Lunch- Berkeley Square- Mayfair. Oil on canvas. 40cm x 50cm. 2012",
  },
  {
    image: coventGarden,
    imageSm: coventGardenSm,
    title: "Covent Garden",
    description: "Oil on canvas. 40cm x 50cm. 2012",
    alt: "Covent Garden. Oil on canvas. 40cm x 50cm. 2012",
  },
  {
    image: nightIsYoung,
    imageSm: nightIsYoungSm,
    title: "The Night is Young- Oxford Circus, London",
    description: "Oil on canvas. 40cm x 50cm. 2012",
    alt: "The Night is Young- Oxford Circus, London. Oil on canvas. 40cm x 50cm. 2012",
  },
  {
    image: piccadilyCircus1961,
    imageSm: piccadilyCircus1961Sm,
    title: "Piccadilly Circus 1961- London",
    description: "Oil on canvas. 61cm X 91cm. 2013",
    alt: "Piccadilly Circus 1961- London. Oil on canvas. 61cm X 91cm. 2013",
  },
  {
    image: greenPark,
    imageSm: greenParkSm,
    title: "July heat wave- Green Park",
    description: "Oil on canvas. 75cm x 100cm. 2013",
    alt: "July heat wave- Green Park. Oil on canvas. 75cm x 100cm. 2013",
  },
  {
    image: flowerMarket,
    imageSm: flowerMarketSm,
    title: "Approach to Columbia Road Flower Market- London",
    description: "Oil on canvas. 20cm x 30cm. 2013",
    alt: "Approach to Columbia Road Flower Market- London. Oil on canvas. 20cm x 30cm. 2013",
  },
  {
    image: shootingStar,
    imageSm: shootingStarSm,
    title: "Shooting Star",
    description: "Oil on canvas. 115cm x 140cm. 2010",
    alt: "Shooting Star. Oil on canvas. 115cm x 140cm. 2010",
  },
  {
    image: fountainOfYouth,
    imageSm: fountainOfYouthSm,
    title: "Fountain of Youth",
    description: "Oil on canvas. 70cm x 89cm. 2011-2013",
    alt: "Fountain of Youth- Mission Bay. Oil on canvas. 70cm x 89cm. 2011-2013",
  },
  {
    image: novemberNights,
    imageSm: novemberNightsSm,
    title: "November Nights",
    description: "Oil on canvas. 80cm x 100cm. 2011",
    alt: "November Nights. Oil on canvas. 80cm x 100cm. 2011",
  },
  {
    image: avenueOfAmericas,
    imageSm: avenueOfAmericasSm,
    title: "49th Street & Avenue of Americas",
    description: "Oil on canvas. 80cm x 100cm. 2011",
    alt: "49th Street & Avenue of Americas. Oil on canvas. 80cm x 100cm. 2011",
  },
  {
    image: futureOpeningNight,
    imageSm: futureOpeningNightSm,
    title: "Tyrone's Future opening night at Anton Kern Gallery, New York",
    description: "Oil on canvas. 50cm x 60cm. 2009",
    alt: "Tyrone's Future opening night at Anton Kern Gallery, New York. Oil on canvas. 50cm x 60cm. 2009",
  },
  {
    image: fortySecondSt,
    imageSm: fortySecondStSm,
    title: "42nd Street, New York",
    description: "Oil on canvas. 55cm x 45cm. 2011-2013",
    alt: "42nd Street, New York. Oil on canvas. 55cm x 45cm. 2011-2013",
  },
  {
    image: incomingTide,
    imageSm: incomingTideSm,
    title: "Incoming Tide",
    description: "Oil on canvas. 180cm x 300cm. 2014",
    alt: "Incoming Tide. Oil on canvas. 180cm x 300cm. 2014",
  },
  {
    image: theBanker,
    imageSm: theBankerSm,
    title: "The Banker",
    description: "Oil on cardboard. 39cm x 48cm. 2010",
    alt: "The Banker. Oil on cardboard. 39cm x 48cm. 2010",
  },
  {
    image: jafa,
    imageSm: jafaSm,
    title: "Jafa",
    description: "Oil on canvas. 130cm X 110cm. 2014",
    alt: "Jafa. Oil on canvas. 130cm X 110cm. 2014",
  },
  {
    image: realGroovy,
    imageSm: realGroovySm,
    title: "Real Groovy",
    description: "Oil on canvas. 38cm x 48cm. 2011",
    alt: "Real Groovy. Oil on canvas. 38cm x 48cm. 2011",
  },
  {
    image: intoxicatedCity,
    imageSm: intoxicatedCitySm,
    title: "Intoxicated City",
    description: "Oil on canvas. 110cm X 130cm. 2014",
    alt: "Intoxicated City. Oil on canvas. 110cm X 130cm. 2014",
  },
  {
    image: spiltCoke,
    imageSm: spiltCokeSm,
    title: "Spilt coke on queen street",
    description: "Oil on board. 40cm x 50cm. 2014",
    alt: "Spilt coke on queen street. Oil on board. 40cm x 50cm. 2014",
  },
  {
    image: pointChevIV,
    imageSm: pointChevIVSm,
    title: "Point Chevalier IV",
    description: "Oil on canvas. 210cm x 390cm. 2011",
    alt: "Point Chevalier IV. Oil on canvas. 210cm x 390cm. 2011",
  },
  {
    image: armedRobbers,
    imageSm: armedRobbersSm,
    title: "Armed Robbers",
    description: "Oil on canvas. 110cm X 130cm. 2014",
    alt: "Armed Robbers. Oil on canvas. 110cm X 130cm. 2014",
  },
  {
    image: bonfire,
    imageSm: bonfireSm,
    title: "The Bonfire",
    description: "Oil on canvas. 39cm x 48cm. 2011",
    alt: "The Bonfire. Oil on canvas. 39cm x 48cm. 2011",
  },
  {
    image: kRoad,
    imageSm: kRoadSm,
    title: "K Road",
    description: "Oil on board. 35cm X 45cm. 2014",
    alt: "K Road. Oil on board. 35cm X 45cm. 2014",
  },
  {
    image: labourDay,
    imageSm: labourDaySm,
    title: "Pre-Labour Day",
    description: "Oil on cardboard. 39cm x 48cm. 2010",
    alt: "Pre-Labour Day. Oil on cardboard. 39cm x 48cm. 2010",
  },
  {
    image: pursuitOfHappiness,
    imageSm: pursuitOfHappinessSm,
    title: "Pursuit of Happiness",
    description: "Oil on board. 45cm x 61cm. 2009",
    alt: "Pursuit of Hapiness. Oil on board. 45cm x 61cm. 2009",
  },
  {
    image: thinkingOutLoud,
    imageSm: thinkingOutLoudSm,
    title: "Thinking out loud",
    description: "Oil on cardboard. 39cm x 48cm. 2010",
    alt: "Thinking out loud. Oil on cardboard. 39cm x 48cm. 2010",
  },
  {
    image: pointChev2,
    imageSm: pointChev2Sm,
    title: "Point Chev II",
    description: "Oil on cardboard. 39cm x 48cm. 2010",
    alt: "Point Chev II. Oil on cardboard. 39cm x 48cm. 2010",
  },
  {
    image: thePsychologist,
    imageSm: thePsychologistSm,
    title: "The Psychologist",
    description: "Oil on cardboard. 39cm x 48cm. 2010",
    alt: "The Psychologist. Oil on cardboard. 39cm x 48cm. 2010",
  },
  {
    image: theYear2064,
    imageSm: theYear2064Sm,
    title: "Auckland Summer, The Year 2064",
    description: "Oil on canvas. 22cm X 28cm. 2014",
    alt: "Auckland Summer- The Year 2064. Oil on canvas. 22cm X 28cm. 2014",
  },
  {
    image: camel,
    imageSm: camelSm,
    title: "Camel",
    description: "Oil on canvas. 100cm x 150cm. 2010",
    alt: "Camel. Oil on canvas. 100cm x 150cm. 2010",
  },
  {
    image: lion,
    imageSm: lionSm,
    title: "Lion",
    description: "Oil on canvas. 100cm x 150cm. 2010",
    alt: "Lion. Oil on canvas. 100cm x 150cm. 2010",
  },
  {
    image: swineFluBritomart,
    imageSm: swineFluBritomartSm,
    title: "Dawn of the swine flu at Britomart",
    description: "Oil on canvas. 50cm x 60cm. 2009",
    alt: "Dawn of the swine flu at Britomart. Oil on canvas. 50cm x 60cm. 2009",
  },
  {
    image: pointChev,
    imageSm: pointChevSm,
    title: "New Sand at Point Chevalier",
    description: "Oil on canvas. 50cm x 60cm. 2009",
    alt: "New Sand at Point Chevalier. Oil on canvas. 50cm x 60cm. 2009",
  },
  {
    image: happyAsLarry,
    imageSm: happyAsLarrySm,
    title: "Happy as Larry",
    description: "Oil on canvas. 50cm x 60cm. 2009",
    alt: "Happy as Larry, Oil on canvas. 50cm x 60cm. 2009",
  },
  {
    image: theImpressionists,
    imageSm: theImpressionistsSm,
    title: "Tyrone and the Impressionists",
    description: "Oil on canvas. 50cm x 60cm. 2009",
    alt: "Tyrone and the Impressionists. Oil on canvas. 50cm x 60cm. 2009",
  },
  {
    image: palermoHollywood,
    imageSm: palermoHollywoodSm,
    title: "Palermo Hollywood- Buenos Aires",
    description: "Oil on cardboard. 39cm x 48cm. 2010",
    alt: "Palermo Hollywood- Buenos Aires. Oil on cardboard. 39cm x 48cm. 2010",
  },
  {
    image: kiwisInPeru,
    imageSm: kiwisInPeruSm,
    title: "18 Kiwi's in Peru",
    description: "Oil on canvas. 140cm x 180cm. 2008-2009",
    alt: "18 Kiwi's in Peru. Oil on canvas. 140cm x 180cm. 2008-2009",
  },
  {
    image: mullins,
    imageSm: mullinsSm,
    title: "Afternoon sea bath at Mullins- Barbados",
    description: "Oil on canvas. 30cm x 40cm. 2012",
    alt: "Afternoon sea bath at Mullins- Barbados. Oil on canvas. 30cm x 40cm. 2012",
  },
  {
    image: carlisleBay,
    imageSm: carlisleBaySm,
    title: "Carlisle Bay- Barbados",
    description: "Oil on canvas. 30cm x 40cm. 2012",
    alt: "Carlisle Bay- Barbados. Oil on canvas. 30cm x 40cm. 2012",
  },
  {
    image: fogOnQueenSt,
    imageSm: fogOnQueenStSm,
    title: "Fog on Queen St",
    description: "Oil on canvas. 22cm X 28cm. 2011",
    alt: "Fog on Queen St. Oil on canvas. 22cm X 28cm. 2011",
  },
  {
    image: missionBay,
    imageSm: missionBaySm,
    title: "(Mission Bay)",
    description: "Oil on canvas. 22cm X 28cm. 2014",
    alt: "(Mission Bay). Oil on canvas. 22cm X 28cm. 2014",
  },
  ];

export default cityscapesCollection;
